import React, { useState, useEffect } from "react";

import { GetSingleTvSeriesResponse } from "../../../../../../../common/api/catalogue-api/tv-api/GetSingleTvSeriesResponse";
import { TvSeasonDocumentResponse } from "../../../../../../../common/api/catalogue-api/tv-api/TvSeriesDocumentResponse";
import {
    TvSeasonResponse,
    EpisodeResponse,
    EpisodeVersionResponse
} from "../../../../../../../common/api/catalogue-api/tv-api/TvSeriesResponse";
import { useCatalogueTvApi } from "../../../../../../../common/api/catalogue-api/tv-api/useCatalogueTvApi";
import { BuzzVersionsList } from "../../../../../common/buzz-version/BuzzVersionsList";
import { MediaBuzzVersion, mapToMediaBuzzVersion } from "../../../../../common/buzz-version/MediaBuzzVersion";

interface CloudTvSeriesVersionInfoProps {
    tvSeriesId: string;
    seasonId: string;
    episodeId: string;
    versionIds: string[];
}

export const CloudTvSeriesVersionInfo: React.FC<CloudTvSeriesVersionInfoProps> = (
    props: CloudTvSeriesVersionInfoProps
) => {
    const { tvSeriesId, seasonId, episodeId, versionIds } = props;

    const { getSingleTvSeries } = useCatalogueTvApi();

    const [episodeBuzzVersions, setEpisodeBuzzVersions] = useState<MediaBuzzVersion[]>([]);

    useEffect(() => {
        getSingleTvSeries(tvSeriesId).then((response: GetSingleTvSeriesResponse) => {
            const episodeVersions = findFilteredEpisodeVersions(response.seasons);
            const versions = episodeVersions?.map(mapToMediaBuzzVersion) || [];

            setEpisodeBuzzVersions(versions);
        });
    }, [tvSeriesId]);

    const findFilteredEpisodeVersions = (seasons: TvSeasonDocumentResponse[]) => {
        return seasons
            .find((season: TvSeasonResponse) => season.id === seasonId)
            ?.episodes.find((episode: EpisodeResponse) => episode.id === episodeId)
            ?.versions.filter((version: EpisodeVersionResponse) => versionIds.includes(version.id));
    };

    return <BuzzVersionsList versions={episodeBuzzVersions} />;
};
